import { Injector } from '@angular/core';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { RECIPE_STEP_NODE_NAME } from '../recipe.model';
import { RecipeStepComponent } from './recipe-step.component';

const stepClassName = 'recipe-step-block';

export const RecipeStepExtension = (injector: Injector) => {
  return Node.create({
    name: RECIPE_STEP_NODE_NAME,
    content: 'block+',
    defining: true,
    isolating: true,
    selectable: false,
    draggable: false,

    addAttributes() {
      return {
        title: {
          default: '',
        },
      };
    },

    parseHTML() {
      return [{ tag: `div.${stepClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: stepClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(RecipeStepComponent, {
        injector,
      });
    },
  });
};
